import BaseCRUDReducer from './CRUDReducer';
import { PromotionCRUDActions } from '../actions/promotion';

const CRUDReducer = new BaseCRUDReducer(new PromotionCRUDActions());

export default (state, action) => CRUDReducer.run(state, action);



// WEBPACK FOOTER //
// ./src/reducers/promotion.js